<template>
  <link
    rel="preconnect"
    href="https://fonts.googleapis.com"
  >
  <link
    rel="preconnect"
    href="https://fonts.gstatic.com"
    crossorigin
  >
  <link
    href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
    rel="stylesheet"
  >

  <div class="app flex flex-row">
    <div class="flex-1 max-h-screen overflow-auto">
      <slot />
    </div>
  </div>

  <div id="modal" />
  <template v-if="arEnableAudienceAI">
    <AudienceAIFloatingButton />
    <AudienceAIPanel />
  </template>
  <GlobalDrawer />
</template>

<script lang="ts" setup>
import { useColorMode, useCycleList } from '@vueuse/core'
import { watchEffect } from 'vue-demi'
import { useRoute } from 'vue-router'
import Sidebar from '@/components/am3/navigation/Sidebar.vue'
import AudienceAIFloatingButton from '@/components/am3/floating/AudienceAIFloatingButton.vue'
import AudienceAIPanel from '@/components/am3/floating/AudienceAIPanel.vue'
import GlobalDrawer from '@/components/am3/modals/GlobalDrawer.vue'

const route = useRoute()

const config = useRuntimeConfig().public
const arEnableAudienceAI = config.arEnableAudienceAI

const mode = useColorMode({
  emitAuto: true,
  modes: {
    // contrast: 'dark contrast',
    // classic: 'theme-classic',
    audience: 'theme-audience',
    // dark: 'theme-dark',
    // nightmare: 'theme-nightmare',
  },
})

const { state, next } = useCycleList([
  // 'classic' ,
  'audience',
  // 'dark',
  // 'nightmare',
] as const, { initialValue: mode })

watchEffect(() => mode.value = state.value)
</script>
